import React from 'react';
import { Sender } from 'modules/chatbot/enums/Sender';
import { EventType, MessageStatus } from 'modules/chatbot/types/chatbot.types';
import BotMessageBubble from 'modules/chatbot/components/BotMessageBubble/BotMessageBubble';
import UserMessageBubble from 'modules/chatbot/components/UserMessageBubble/UserMessageBubble';
import { SourceItem } from 'modules/chatbot/components/CollapsibleSources';
import { selectIsTypingAnimate } from 'modules/chatbot/slices/chatbotSlice';
import { useAppSelector } from 'hooks/redux';

type ChatBubbleProps = {
  content?: string;
  sender: Sender;
  isPending?: boolean;
  messageId?: string;
  eventType?: EventType;
  status?: MessageStatus;
  sources?: SourceItem[];
};

const ChatBubble: React.FC<ChatBubbleProps> = ({
  content,
  sender,
  isPending = false,
  messageId,
  eventType,
  status,
  sources,
}: ChatBubbleProps) => {
  const isBotOrSystem = [Sender.BOT, Sender.SYSTEM].includes(sender);
  const typingAnimation = useAppSelector(selectIsTypingAnimate);

  if (isBotOrSystem) {
    return (
      <BotMessageBubble
        content={content}
        isPending={isPending}
        messageId={messageId}
        eventType={eventType}
        status={status}
        sources={sources}
        sender={sender}
        animate={
          typingAnimation?.isTyping &&
          typingAnimation?.messageId === messageId &&
          [EventType.CHUNK, EventType.COMPLETE, EventType.ACTION].includes(
            eventType!
          )
        }
      />
    );
  }

  return <UserMessageBubble content={content} />;
};

export default ChatBubble;
